<template>
  <div class="container">
    <div @click="handleClick" class="mt-20 text-center cursor-pointer" style="max-height: 300px; overflow: hidden;">
      <img :src="bannerAd.coverurl" alt="" style="width: 100%; height: 100%; object-fit: cover;" />
    </div>
  </div>
</template>

<script>
import { getAds, clickPlacement } from '@/api/placement';
import config from '@/config';
export default {
  name: 'SingleAd',
  data() {
    return {
      bannerAd: {}
    }
  },
  created() {
    this.fetchBannerAdData();
  },
  methods: {
    fetchBannerAdData() {
      getAds(config.AD_PLACEMENT_BANNER).then(res => {
        if (res.code === 200) {
          this.bannerAd = res.data[0] || {};
        }
      });
    },
    handleClick() {
      const url = clickPlacement(this.bannerAd.placementid, this.bannerAd);
      window.open(url, '_blank');
    }
  }
}
</script>
